import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { PublicRoute } from '@gsa/afp-shared-ui-utils';
import VehicleStandardsPage from './landing-page';
import DocPreview from './doc-preview';
import FvsProvider from './fvs-provider';
import FvsSupportingDocsProvider from './fvs-supporting-docs-provider';
import CommentingPeriods from './commenting-periods';
import Requirements from './requirements';
import FvsCommentsProvider from './fvs-comments-provider';
import ViewComments from './comments/view-comments';

const FedVehicleStandards = () => {
  return (
    <FvsProvider>
      <FvsSupportingDocsProvider>
        <FvsCommentsProvider>
          <Routes>
            <Route
              path="/fvs/vehicle-standards"
              element={
                <PublicRoute title="Federal Vehicle Standards">
                  <VehicleStandardsPage />
                </PublicRoute>
              }
            />
            <Route
              path="/fvs/vehicle-standards/requirements"
              element={
                <PublicRoute title="Vehicle Requirements">
                  <Requirements />
                </PublicRoute>
              }
            />
            <Route
              path="/fvs/comments"
              element={
                <PublicRoute title="Comments">
                  <ViewComments />
                </PublicRoute>
              }
            />
            <Route
              path="/fvs/vehicle-standards/commenting-periods"
              element={
                <PublicRoute title="Commenting Periods">
                  <CommentingPeriods />
                </PublicRoute>
              }
            />
            <Route
              path="/fvs/vehicle-standards/preview/:year/:fvsId/:docId?"
              element={
                <PublicRoute title="Vehicle Standards Documentation">
                  <DocPreview />
                </PublicRoute>
              }
            />
          </Routes>
        </FvsCommentsProvider>
      </FvsSupportingDocsProvider>
    </FvsProvider>
  );
};

export default FedVehicleStandards;
